import React from 'react';
import styled, { css } from 'styled-components';
import { FaArrowRight } from 'react-icons/fa';
import media from '../../base/media';

const headerGray = '#BFBFBF';
const transitionSpeed = '200ms';

export const Wrapper = styled.div`
	display: flex;
	justify-content: space-between;

	${media.tablet`
		margin-top: 3rem;
	`}
`;

export const LevelText = styled.div`
	font-weight: 700;
	font-size: 1rem;
	line-height: 2.2rem;
	margin-bottom: 3rem;
	color: ${({ theme }) => theme.colors.black};
	transition: color ${transitionSpeed} ease;

	${media.tablet`
		font-size: 1.8rem;
	`}
`;

export const LevelLineWrapper = styled.div`
	position: relative;
	width: 100%;
`;

export const LevelLine = styled.div`
	height: 1px;
	width: 100%;
	background-color: ${headerGray};
	z-index: 0;
	transition: background-color ${transitionSpeed} ease;
`;

export const StyledLevelLineIcon = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${headerGray};
	height: 3rem;
	width: 3rem;
	border-radius: 100%;
	color: #fff;
	font-size: 1.6rem;
	transition: background-color ${transitionSpeed} ease;

	transform: translate3d(-50%, -50%, 0);
	z-index: 2;
`;

export const LevelLineIcon = props => (
	<StyledLevelLineIcon {...props}>
		<FaArrowRight />
	</StyledLevelLineIcon>
);

export const Level = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	flex: 100% 1 1;
	padding-bottom: 4rem;
	cursor: pointer;

	${media.desktopSmall`
		padding-bottom: 10rem;
	`}

	${({ disabled }) => disabled && css`
		pointer-events: none;
	`}

	${({ active }) => active && css`
		${LevelText} {
			color: ${({ theme }) => theme.colors.primary};
		}

		${LevelLine}, ${StyledLevelLineIcon} {
			background-color: ${({ theme }) => theme.colors.primary};
		}
	`}

	${({ completed }) => completed && css`
		${LevelText} {
			color: ${({ theme }) => theme.colors.success};
		}

		${LevelLine}, ${StyledLevelLineIcon} {
			background-color: ${({ theme }) => theme.colors.success};
		}
	`}
`;
